import React from 'react';
import CircularProgress from '@mui/material/CircularProgress';

interface RestorePreviousByFlagButtonProps {
  flag: string;
  loading: boolean;
  disabled?: boolean;
  onClick: () => void;
}

const RestorePreviousByFlagButton: React.FC<RestorePreviousByFlagButtonProps> = ({
  flag,
  loading,
  disabled = false,
  onClick,
}) => {
  const label = flag.charAt(0).toUpperCase() + flag.slice(1);

  return (
    <button
      type='button'
      className={`btn-outline bdb-restore-by-flag-btn${
        loading ? ' is-loading' : ''
      }`}
      disabled={disabled || loading}
      onClick={onClick}
      aria-busy={loading}
    >
      <span className='bdb-restore-by-flag-label'>
        Restore all that were {label}
      </span>
      <span className='bdb-restore-by-flag-spinner' aria-hidden={!loading}>
        <CircularProgress
          size={14}
          thickness={5}
          sx={{ color: 'var(--text-primary-color)' }}
        />
      </span>
    </button>
  );
};

export default RestorePreviousByFlagButton;
